import {Locale} from '@hebcal/hdate';
import poData from './he.po.js';
Locale.addTranslations('he', poData);

const poHeNoNikud = Locale.copyLocaleNoNikud(poData);
Locale.addTranslations('he-x-NoNikud', poHeNoNikud);
